import React from "react"
import {graphql} from "gatsby"
import {Dialog} from "@reach/dialog";

import Layout from "../components/Layout"
import * as styles from "../components/hero/hero.module.scss";
import AppointmentForm from "../components/forms/AppointmentForm";
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs";
import parse from "html-react-parser";

const NotFoundPage = ({data: {wpPage}}) => {

    const [showDialog, setShowDialog] = React.useState(false);
    const open = () => setShowDialog(true);
    const close = () => setShowDialog(false);

    const {
        title,
        seo,
        content
    } = wpPage;

    return (
        <Layout seo={seo}>
            <section className={styles.hero}>
                <div className="grid-container-wrap">
                    <div className="grid-container">
                        <div className="grid-colstart-2-xl-min grid-colend-8-xl-min grid-col-8-xl-md grid-col-9-md-sm grid-col-10-sm-xs">
                            <Breadcrumbs pageTitle={title} breadcrumbs={null} />
                            <h1 className={styles.heroTitle}>{title}</h1>
                        </div>

                        <div className="grid-colstart-2-xl-min grid-colend-7-xl-min grid-col-6-xl-md grid-col-7-md-sm grid-col-9-sm-xs">
                            {content ?
                                parse(content)
                            :
                                <>
                                <p>Was je naar iets opzoek of heb je onze website gesloopt?</p>
                                <p>Misschien kunnen/willen wij je wel helpen. Bel ons, mail ons of spam ons via het contact formulier!</p>
                                </>
                            }

                            <a className={`btn btn-secondary btn-sm`} onClick={open}>
                                Contact opnemen
                            </a>
                            <a href={`/`} className={`btn btn-primary btn-flat btn-sm`}>
                                Naar homepage
                            </a>

                            <Dialog isOpen={showDialog} onDismiss={close}>
                                <button className="close-button" onClick={close}>
                                    <span className="sr-only">Close</span>
                                    <span aria-hidden>×</span>
                                </button>
                                <h4 className="modal-title">Contact opnemen</h4>
                                <p>Bel ons via <a href={`tel:0031854010875`}>085 401 0875</a>, mail naar <a href={`mailto:info@tpf.nu`}>info@tpf.nu</a> of vul dit formulier in. Wij nemen zo snel mogelijk contact met je op!</p>
                                <div className="price-form">
                                    <AppointmentForm />
                                </div>
                            </Dialog>
                        </div>
                    </div>
                    <figure className={styles.heroImage}>
                        <svg className={styles.heroOops} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             viewBox="0 0 643.088 849.999">
                            <g id={styles.heroImage}>
                                <g className={styles.heroCape}>
                                    <path d="M482.001,671.285c-19.373-48.62-48.882-199.603-60.817-249.517c-6.604-27.667,0.918-115.214-13.96-170.16
				c-0.717-2.653-152.456-7.625-151.335,35.606c-22.415,84.616-18.563,165.772-14.116,253.333c2.343,46.177,13.926,85.33,22.2,130.815
				c5.126,28.173-6.182,73.229,19.636,90.725c28.471,19.291,57.229-9.92,100.049-1.598c18.074,3.511,30.248,24.107,46.588,30.063
				c11.945,4.345,22.76,0.732,33.907-3.966c7.011-2.95,13.818-8.959,21.544-8.857c7.773,0.089,16.579,16.62,34.719,19.214
				c49.85,7.111,56.728-43.345,62.308-73.771C517.65,755.942,491.85,696.001,482.001,671.285"/>
                                </g>
                                <g className={styles.heroDots} opacity="0.25">
                                    <circle id="Ellipse_228" cx="406.111" cy="280.303" r="5.484"/>
                                    <circle id="Ellipse_230" cx="387.83" cy="280.304" r="9.141"/>
                                    <circle id="Ellipse_237" cx="424.393" cy="280.304" r="2.742"/>
                                    <circle id="Ellipse_228_1_" cx="406.111" cy="298.585" r="5.484"/>
                                    <circle id="Ellipse_230_1_" cx="387.83" cy="298.586" r="9.141"/>
                                    <circle id="Ellipse_237_1_" cx="424.393" cy="298.586" r="2.742"/>
                                    <circle id="Ellipse_228_3_" cx="387.799" cy="316.867" r="5.484"/>
                                    <circle id="Ellipse_230_3_" cx="369.518" cy="316.868" r="9.141"/>
                                    <circle id="Ellipse_237_3_" cx="406.08" cy="316.868" r="2.742"/>
                                    <circle id="Ellipse_228_2_" cx="369.633" cy="335.149" r="5.484"/>
                                    <circle id="Ellipse_237_2_" cx="387.914" cy="335.15" r="2.742"/>
                                    <circle id="Ellipse_228_4_" cx="369.633" cy="353.43" r="5.484"/>
                                    <circle id="Ellipse_237_4_" cx="387.914" cy="353.431" r="2.742"/>
                                    <circle id="Ellipse_228_5_" cx="369.633" cy="371.712" r="5.484"/>
                                    <circle id="Ellipse_237_5_" cx="387.914" cy="371.713" r="2.742"/>
                                    <circle id="Ellipse_228_6_" cx="387.799" cy="389.994" r="5.484"/>
                                    <circle id="Ellipse_230_6_" cx="369.518" cy="389.995" r="9.141"/>
                                    <circle id="Ellipse_237_6_" cx="406.08" cy="389.995" r="2.742"/>
                                    <circle id="Ellipse_228_8_" cx="387.799" cy="426.557" r="5.484"/>
                                    <circle id="Ellipse_228_33_" cx="406.08" cy="426.557" r="5.484"/>
                                    <circle id="Ellipse_230_7_" cx="406.536" cy="408.277" r="9.141"/>
                                    <circle id="Ellipse_228_7_" cx="387.799" cy="444.839" r="5.484"/>
                                    <circle id="Ellipse_237_7_" cx="406.08" cy="444.84" r="2.742"/>
                                    <circle id="Ellipse_228_9_" cx="387.799" cy="463.12" r="5.484"/>
                                    <circle id="Ellipse_237_9_" cx="406.08" cy="463.122" r="2.742"/>
                                    <circle id="Ellipse_228_10_" cx="406.537" cy="481.401" r="5.484"/>
                                    <circle id="Ellipse_230_11_" cx="388.256" cy="481.403" r="9.141"/>
                                    <circle id="Ellipse_237_10_" cx="424.818" cy="481.403" r="2.742"/>
                                    <circle id="Ellipse_228_11_" cx="406.537" cy="499.683" r="5.484"/>
                                    <circle id="Ellipse_230_12_" cx="388.256" cy="499.684" r="9.141"/>
                                    <circle id="Ellipse_237_11_" cx="424.818" cy="499.684" r="2.742"/>
                                    <circle id="Ellipse_228_12_" cx="406.537" cy="517.964" r="5.484"/>
                                    <circle id="Ellipse_230_13_" cx="388.256" cy="517.965" r="9.141"/>
                                    <circle id="Ellipse_237_12_" cx="424.818" cy="517.965" r="2.742"/>
                                    <circle id="Ellipse_228_13_" cx="406.537" cy="536.245" r="5.484"/>
                                    <circle id="Ellipse_230_14_" cx="388.256" cy="536.247" r="9.141"/>
                                    <circle id="Ellipse_237_13_" cx="424.818" cy="536.247" r="2.742"/>
                                    <circle id="Ellipse_228_14_" cx="406.537" cy="554.526" r="5.484"/>
                                    <circle id="Ellipse_230_15_" cx="388.256" cy="554.528" r="9.141"/>
                                    <circle id="Ellipse_237_14_" cx="424.818" cy="554.528" r="2.742"/>
                                    <circle id="Ellipse_228_15_" cx="406.537" cy="572.808" r="5.484"/>
                                    <circle id="Ellipse_230_16_" cx="388.256" cy="572.809" r="9.141"/>
                                    <circle id="Ellipse_237_15_" cx="424.818" cy="572.809" r="2.742"/>
                                    <circle id="Ellipse_228_16_" cx="406.537" cy="591.089" r="5.484"/>
                                    <circle id="Ellipse_230_17_" cx="388.256" cy="591.09" r="9.141"/>
                                    <circle id="Ellipse_237_16_" cx="424.818" cy="591.09" r="2.742"/>
                                    <circle id="Ellipse_228_17_" cx="406.537" cy="609.371" r="5.484"/>
                                    <circle id="Ellipse_230_18_" cx="388.256" cy="609.373" r="9.141"/>
                                    <circle id="Ellipse_237_17_" cx="424.818" cy="609.373" r="2.742"/>
                                    <circle id="Ellipse_228_18_" cx="406.537" cy="627.652" r="5.484"/>
                                    <circle id="Ellipse_230_19_" cx="388.256" cy="627.654" r="9.141"/>
                                    <circle id="Ellipse_230_28_" cx="278.563" cy="627.654" r="9.141"/>
                                    <circle id="Ellipse_237_18_" cx="424.818" cy="627.654" r="2.742"/>
                                    <circle id="Ellipse_228_27_" cx="296.844" cy="627.652" r="5.484"/>
                                    <circle id="Ellipse_237_27_" cx="315.125" cy="627.654" r="2.742"/>
                                    <circle id="Ellipse_230_35_" cx="278.563" cy="609.372" r="9.141"/>
                                    <circle id="Ellipse_228_34_" cx="296.844" cy="609.37" r="5.484"/>
                                    <circle id="Ellipse_237_34_" cx="315.125" cy="609.372" r="2.742"/>
                                    <circle id="Ellipse_230_36_" cx="278.563" cy="591.089" r="9.141"/>
                                    <circle id="Ellipse_228_35_" cx="296.844" cy="591.088" r="5.484"/>
                                    <circle id="Ellipse_237_35_" cx="315.125" cy="591.089" r="2.742"/>
                                    <circle id="Ellipse_230_37_" cx="297.301" cy="572.809" r="9.141"/>
                                    <circle id="Ellipse_228_36_" cx="315.582" cy="572.808" r="5.484"/>
                                    <circle id="Ellipse_230_38_" cx="297.301" cy="554.528" r="9.141"/>
                                    <circle id="Ellipse_228_37_" cx="315.582" cy="554.526" r="5.484"/>
                                    <circle id="Ellipse_230_39_" cx="297.301" cy="536.247" r="9.141"/>
                                    <circle id="Ellipse_228_38_" cx="315.582" cy="536.245" r="5.484"/>
                                    <circle id="Ellipse_230_40_" cx="315.583" cy="517.965" r="9.141"/>
                                    <circle id="Ellipse_230_43_" cx="297.301" cy="517.965" r="9.141"/>
                                    <circle id="Ellipse_230_41_" cx="315.583" cy="499.683" r="9.141"/>
                                    <circle id="Ellipse_230_42_" cx="315.583" cy="481.403" r="9.141"/>
                                    <circle id="Ellipse_230_29_" cx="278.563" cy="645.936" r="9.141"/>
                                    <circle id="Ellipse_228_28_" cx="296.844" cy="645.935" r="5.484"/>
                                    <circle id="Ellipse_237_28_" cx="315.125" cy="645.936" r="2.742"/>
                                    <circle id="Ellipse_230_30_" cx="278.563" cy="664.216" r="9.141"/>
                                    <circle id="Ellipse_228_29_" cx="296.844" cy="664.215" r="5.484"/>
                                    <circle id="Ellipse_237_29_" cx="315.125" cy="664.216" r="2.742"/>
                                    <circle id="Ellipse_230_31_" cx="278.563" cy="682.499" r="9.141"/>
                                    <circle id="Ellipse_228_30_" cx="296.844" cy="682.497" r="5.484"/>
                                    <circle id="Ellipse_237_30_" cx="315.125" cy="682.499" r="2.742"/>
                                    <circle id="Ellipse_230_32_" cx="278.563" cy="700.779" r="9.141"/>
                                    <circle id="Ellipse_228_31_" cx="296.844" cy="700.777" r="5.484"/>
                                    <circle id="Ellipse_237_31_" cx="315.125" cy="700.779" r="2.742"/>
                                    <circle id="Ellipse_230_33_" cx="278.563" cy="719.06" r="9.141"/>
                                    <circle id="Ellipse_228_32_" cx="296.844" cy="719.059" r="5.484"/>
                                    <circle id="Ellipse_237_32_" cx="315.125" cy="719.06" r="2.742"/>
                                    <circle id="Ellipse_228_39_" cx="278.564" cy="737.34" r="5.484"/>
                                    <circle id="Ellipse_237_33_" cx="296.844" cy="737.341" r="2.742"/>
                                    <circle id="Ellipse_228_19_" cx="406.537" cy="645.935" r="5.484"/>
                                    <circle id="Ellipse_230_20_" cx="388.256" cy="645.936" r="9.141"/>
                                    <circle id="Ellipse_237_19_" cx="424.818" cy="645.936" r="2.742"/>
                                    <circle id="Ellipse_228_20_" cx="406.537" cy="664.216" r="5.484"/>
                                    <circle id="Ellipse_230_21_" cx="388.256" cy="664.217" r="9.141"/>
                                    <circle id="Ellipse_237_20_" cx="424.818" cy="664.217" r="2.742"/>
                                    <circle id="Ellipse_228_21_" cx="424.819" cy="682.497" r="5.484"/>
                                    <circle id="Ellipse_230_22_" cx="406.538" cy="682.499" r="9.141"/>
                                    <circle id="Ellipse_237_21_" cx="443.101" cy="682.499" r="2.742"/>
                                    <circle id="Ellipse_228_22_" cx="424.819" cy="700.778" r="5.484"/>
                                    <circle id="Ellipse_230_23_" cx="406.538" cy="700.78" r="9.141"/>
                                    <circle id="Ellipse_237_22_" cx="443.101" cy="700.78" r="2.742"/>
                                    <circle id="Ellipse_228_23_" cx="424.819" cy="719.06" r="5.484"/>
                                    <circle id="Ellipse_230_24_" cx="406.538" cy="719.061" r="9.141"/>
                                    <circle id="Ellipse_237_23_" cx="443.101" cy="719.061" r="2.742"/>
                                    <circle id="Ellipse_228_24_" cx="424.819" cy="737.341" r="5.484"/>
                                    <circle id="Ellipse_230_25_" cx="406.538" cy="737.342" r="9.141"/>
                                    <circle id="Ellipse_237_24_" cx="443.101" cy="737.342" r="2.742"/>
                                    <circle id="Ellipse_228_25_" cx="424.819" cy="755.623" r="5.484"/>
                                    <circle id="Ellipse_237_25_" cx="443.101" cy="755.625" r="2.742"/>
                                    <circle id="Ellipse_228_26_" cx="424.819" cy="773.904" r="5.484"/>
                                    <circle id="Ellipse_237_26_" cx="443.101" cy="773.906" r="2.742"/>
                                </g>
                                <g>
                                    <path className={styles.heroCloud} d="M643.088,85.002C643.088,38.057,582.837,0,508.518,0C434.191,0,373.94,38.057,373.94,85.002
				c0,43.148,50.91,78.761,116.848,84.245c-0.018,0.146,0.006,0.292-0.012,0.438c-0.149,1.246-0.399,2.531-0.906,3.758
				c-0.43,1.294-1.157,2.48-1.955,3.735c-0.888,1.16-1.884,2.346-3.064,3.359c-2.318,2.063-5.043,3.792-7.564,4.978
				c-2.504,1.264-4.794,2.098-6.397,2.646c-1.626,0.542-2.557,0.853-2.557,0.853s0.948,0.262,2.616,0.721
				c1.682,0.447,4.114,1.05,7.185,1.437c3.063,0.459,6.795,0.626,11.04,0.119c2.128-0.239,4.345-0.775,6.658-1.496
				c2.254-0.829,4.621-1.813,6.813-3.231c2.248-1.318,4.358-3.041,6.236-4.865c1.938-1.848,3.571-3.845,5.031-5.896
				c1.467-2.012,2.569-4.039,3.69-6.015C587.677,166.836,643.088,130.016,643.088,85.002z"/>
                                    <text className={styles.heroCloudText} transform="matrix(1 0 0 1 423.2461 107.5928)" font-family="'PW Heading', 'Nephrite-Bold', 'Roboto Condensed', 'Helvetica Neue Condensed', 'Arial Narrow', sans-serif" font-size="73.2526">Oeps...</text>
                                </g>
                                <g>
                                <path className={styles.heroSkin} d="M495.337,308.581c-5.675-12.757-53.599-61.985-53.599-61.985c-11.016-19.226-24.899-31.275-42.929-32.826
			c-0.717-0.277-1.514-0.545-2.412-0.814c-17.437-5.222-37.252-9.771-44.263-17.354c-2.897-1.657-2.629-8.489-6.706-15.738
			c0.023-0.077,0.071-0.197,0.089-0.268c1.443-6.117,2.618-12.162,2.951-18.403c1.729,0.018,4.191-0.471,4.829-3.237
			c1.014-4.375,4.065-14.325-0.626-17.979c-2.289-1.776-4.149-1.347-5.55-0.393c-0.822-2.855-2.498-8.68-4.936-17.151
			c-3.66-12.772-4.387-19.72-4.583-25.518c-2.188,1.953-3.673,4.79-3.673,4.79s-2.885-4.211-7.046-5.293
			c-2.668-0.691-15.554-1.51-27.924,2.002c2.242-10.4-4.782-15.844-19.88-14.419c-14.772,1.383-30.945,19.1-42.433,26.003
			c-14.027,8.435-34.093,34.576-50.016,51.947c-13.162,14.396-9.377,20.149-6.301,26.462c6.123,12.56,51.154,63.237,51.154,63.237
			c2.678,4.319,5.828,7.072,9.264,9.016c8.188,12.207,20.349,23.857,20.984,28.088c4.491,29.925,10.274,40.127,5.118,60.024
			c-0.159,0.584-0.319,1.172-0.479,1.76c-0.038,0.132-0.07,0.259-0.108,0.392c0,0,0.001-0.003,0.003-0.007
			c-5.874,21.463-13.306,45.715-20.808,62.458c-7.768,17.335-14.045,91.179-16.924,142.41c-1.509,26.891,7.583,61.031,2.08,95.602
			c-7.034,44.244,12.895,97.479,0,138.707c-1.991,6.385-11.35,17.014-29.663,25.151c-15.738,6.998-34.76,12.298-35.613,20.353
			c-1.825,17.424,44.662,4.028,63.923,3.517c16.53-0.441,31.684,8.459,36.798-2.504c7.118-15.261-2.325-29.074-1.013-46.797
			c1.216-16.352,29.783-76.305,25.109-133.282c-0.477-5.824-9.359-41.432-8.053-46.069c5.687-20.292,14.229-40.566,18.295-60.501
			c6.415-31.446,12.459-75.542,12.459-75.542s5.724,79.905,12.662,94.618c6.927,14.712,20.757,42.61,21.973,56.269
			c2.182,24.614,5.521,61.348,13.252,85.657c15.321,48.222,32.745,67.148,31.387,85.021c-1.133,14.969-6.521,31.911-3.982,40.119
			c4.794,15.47,21.079,13.687,29.985,13.877c14.271,0.305,27.41-2.664,15.326-38.295c-17.079-50.361-21.573-91.94-25.472-138.874
			c-3.165-38.093-15.607-69.915-14.987-75.381c1.837-16.197,2.104-114.362-3.326-145.468c-2.378-13.64-5.343-26.825-8.444-38.914
			c3.12,3.19,8.793,4.774,16.891,4.291c14.814-0.877,26.528-25.831,38.255-32.335c14.301-7.94,35.255-33.377,51.762-50.188
			C501.787,320.874,498.204,315.001,495.337,308.581z M224.366,179.048c0,0,20.775-37.111,32.956-49.503
			c2,0.442,5.473,1.146,7.36,1.163c-2.325,1.479-7.493,2.814-7.493,2.814s3.613,3.511,10.498,2.015
			c-0.173,5.228,4.59,16.823,7.958,24.322c-1.299,0.262-2.515,1.114-3.278,3.184c-2.027,5.585,5.842,12.399,9.02,15.57
			c2.009,2.003,4.346,1.109,5.806,0.173c3.601,5.121,7.803,9.627,12.268,14.044c0.232,0.221,0.608,0.501,0.9,0.763
			c0.052,0.582,0.105,1.198,0.157,1.833c-6.092,7.853-14.474,11.093-30.011,13.738c-0.105,0.018-0.208,0.038-0.313,0.056
			c-0.711-0.767-1.525-1.64-2.489-2.673C246.25,183.561,224.366,179.048,224.366,179.048z M411.312,368.349
			c-10.306,3.41-21.931,12.215-29.358,25.747c-1.813,3.313-2.92,6.359-3.349,9.083c-8.388-30.487-16.854-51.868-16.854-51.868
			s3.344-26.373,14.057-46.54c5.36-10.091,13.286-20.688,19.707-29.349c3.755,6.083,3.233,5.081,10.278,13.17
			c20.65,23.713,45.223,27.827,45.223,27.827S421.619,364.952,411.312,368.349z"/>

                                <path className={styles.heroCape} d="M352.134,195.602c0,0-18.802,27.011-2.462,30.063c16.346,3.052,44.59-13.343,44.59-13.343
			s-12.087-6.999-17.429-9.289c-5.341-2.289-15.083-1.023-15.083-1.023S359.616,195.292,352.134,195.602"/>
                                <path className={styles.heroCape} d="M300.73,194.13c0,0,1.753,13.664-1.752,22.057c-2.063,4.93-6.73,9.919-14.045,4.966
			c-7.321-4.966-14.739-11.933-14.739-11.933s0.137-2.371,2.078-4.479c6.76-7.343,15.261-4.578,15.261-4.578
			S294.464,194.208,300.73,194.13"/>
                                <path className={styles.heroBelt} d="M257.958,379.282c0,0,17.735,13.896,49.055,16.537c39.172,3.313,66.927-9.085,66.927-9.085l-4.882-17.359
			c0,0-34.319,9.705-58.737,6.605c-25.663-3.243-47.094-14.212-47.094-14.212L257.958,379.282z"/>
                                </g>
                            </g>
                        </svg>
                    </figure>
                </div>
            </section>

        </Layout>
    )
}

export default NotFoundPage

export const pageQuery = graphql`
  query pageNotFoundQuery {
    wpPage(title: {eq: "Niet gevonden"}) {
      title
      content
      seo {
        title
        metaDesc
        canonical
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphType
      }
    }
  }
`
